<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <table>
      <tr>
        <td style="width: 40%">
          <p class="necessary-bold">
            <span
              :class="
                info.BENEF_BASE != null && info.BENEF_BASE.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Сведения об основаниях, документе (агентский договор, договор
            комиссии, договор поручения, договор доверительного управления, счет
            иной документ)
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="info.BENEF_BASE"
            :onchanged="
              info.BENEF_BASE != null && info.BENEF_BASE.length > 80
                ? (info.BENEF_BASE = info.BENEF_BASE.substr(0, 80))
                : info.BENEF_BASE
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                info.DOC_NUMBER != null && info.DOC_NUMBER.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Номер документа
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="info.DOC_NUMBER"
            :onchanged="
              info.DOC_NUMBER != null && info.DOC_NUMBER.length > 10
                ? (info.DOC_NUMBER = info.DOC_NUMBER.substr(0, 10))
                : info.DOC_NUMBER
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                info.DOC_DATE != null &&
                info.DOC_DATE.length == 10 &&
                !unvalidDocDate
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Дата документа
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="info.DOC_DATE"
            v-mask="'##.##.####'"
            placeholder="дд.мм.гггг"
            @input="info.DOC_DATE = checkDate(info.DOC_DATE)"
            @blur="checkDocDate()"
          />
          <p class="necessary-message" v-if="unvalidDocDate">
            Введите корректную дату документа
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                info.INN != null &&
                (info.INN.length == 10 || info.INN.length == 12)
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            ИНН
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="info.INN"
            v-mask="'############'"
            @blur="getByINN()"
          />
        </td>
      </tr>
      <tr>
        <td class="left-column">
          <p class="necessary-bold">
            <span
              :class="
                info.ORG_FULL_NAME != null && info.ORG_FULL_NAME.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Полное наименование организации
          </p>
        </td>
        <td class="right-column">
          <input
            type="text"
            v-model="info.ORG_FULL_NAME"
            :onchanged="
              info.ORG_FULL_NAME != null && info.ORG_FULL_NAME.length > 1000
                ? (info.ORG_FULL_NAME = info.ORG_FULL_NAME.substr(0, 1000))
                : info.ORG_FULL_NAME
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                info.ORG_BRIEF_NAME != null && info.ORG_BRIEF_NAME.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Краткое наименование организации
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="info.ORG_BRIEF_NAME"
            :onchanged="
              info.ORG_BRIEF_NAME != null && info.ORG_BRIEF_NAME.length > 80
                ? (info.ORG_BRIEF_NAME = info.ORG_BRIEF_NAME.substr(0, 80))
                : info.ORG_BRIEF_NAME
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p>Наименование на иностранном языке (при наличии)</p>
        </td>
        <td>
          <input
            type="text"
            v-model="info.FOREIGN_NAME"
            @input="
              info.FOREIGN_NAME != null && info.FOREIGN_NAME.length > 1000
                ? (info.FOREIGN_NAME = info.FOREIGN_NAME.substr(0, 1000))
                : info.FOREIGN_NAME;
              info.FOREIGN_NAME = info.FOREIGN_NAME.replace(
                /[^0-9a-zA-Z- _,.&:]/g,
                ''
              );
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                info.OPF != null && info.OPF.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            ОПФ
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="info.OPF"
            :onchanged="
              info.OPF != null && info.OPF.length > 80
                ? (info.OPF = info.OPF.substr(0, 80))
                : info.OPF
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                info.OKATO != null && info.OKATO.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            ОКАТО
          </p>
        </td>
        <td>
          <input type="text" v-model="info.OKATO" v-mask="'###########'" />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                info.OGRN != null && info.OGRN.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            ОГРН
          </p>
        </td>
        <td>
          <input type="text" v-model="info.OGRN" v-mask="'#############'" />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                info.UR_ADDRESS != null && info.UR_ADDRESS.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Юридический адрес
          </p>
        </td>
        <td>
          <input
            type="text"
            v-model="info.UR_ADDRESS"
            :onchanged="
              info.UR_ADDRESS != null && info.UR_ADDRESS.length > 1000
                ? (info.UR_ADDRESS = info.UR_ADDRESS.substr(0, 1000))
                : info.UR_ADDRESS
            "
          />
        </td>
      </tr>
      <tr>
        <td>
          <p class="necessary-bold">
            <span
              :class="
                info.FACT_ADDRESS != null && info.FACT_ADDRESS.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Место государственной регистрации (местонахождения)
          </p>
          <label>
            <input
              type="checkbox"
              v-model="live_like_registration"
              :checked="
                live_like_registration
                  ? (info.FACT_ADDRESS = info.UR_ADDRESS)
                  : info.FACT_ADDRESS
              "
            />Cовпадает с юридическим адресом
          </label>
        </td>
        <td>
          <input
            type="text"
            v-model="info.FACT_ADDRESS"
            :disabled="live_like_registration"
            :onchanged="
              info.FACT_ADDRESS != null && info.FACT_ADDRESS.length > 1000
                ? (info.FACT_ADDRESS = info.FACT_ADDRESS.substr(0, 1000))
                : info.FACT_ADDRESS
            "
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import mask from "../utils/my-mask.js";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "FacesEntityTable",
  components: { Loading },
  props: {
    info: {},
    url: String
  },

  data: () => ({
    live_like_registration: false,
    isLoading: false,
    unvalidDocDate: false
  }),
  methods: {
    checkDate(date) {
      return mask.date(date);
    },
    async getByINN() {
      if (
        this.info.INN != null &&
        (this.info.INN.length == 10 || this.info.INN.length == 12)
      ) {
        try {
          this.isLoading = true;
          let response = await fetch(this.url + "get_company_info_by_inn", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ INN: this.info.INN })
          });
          if (response.ok) {
            let json = await response.json();
            if (json.OKATO != null) this.info.OKATO = json.OKATO;
            if (json.OPF != null) this.info.OPF = json.OPF;
            if (json.OGRN != null) this.info.OGRN = json.OGRN;
            if (json.ORG_FULL_NAME != null)
              this.info.ORG_FULL_NAME = json.ORG_FULL_NAME;
            if (json.ORG_BRIEF_NAME != null)
              this.info.ORG_BRIEF_NAME = json.ORG_BRIEF_NAME;
            if (json.UR_ADDRESS != null) this.info.UR_ADDRESS = json.UR_ADDRESS;
          }
        } catch (error) {
          console.log(error);
        }
        this.isLoading = false;
      }
    },
    checkInformation() {
      let a = true;
      a =
        a &&
        this.info.BENEF_BASE != null &&
        this.info.DOC_DATE != null &&
        this.info.DOC_NUMBER != null &&
        this.info.OPF != null &&
        this.info.OKATO != null &&
        this.info.OKATO.length == 11 &&
        this.info.DOC_DATE.length == 10 &&
        this.info.INN != null &&
        (this.info.INN.length == 10 || this.info.INN.length == 12) &&
        this.info.OGRN != null &&
        (this.info.OGRN.length == 10 ||
          this.info.OGRN.length == 12 ||
          this.info.OGRN.length == 13) &&
        this.info.ORG_FULL_NAME != null &&
        this.info.ORG_BRIEF_NAME != null &&
        this.info.UR_ADDRESS != null &&
        this.info.FACT_ADDRESS != null &&
        !this.unvalidDocDate &&
        this.info.OPF.length *
          this.info.FACT_ADDRESS.length *
          this.info.BENEF_BASE.length *
          this.info.DOC_NUMBER.length *
          this.info.UR_ADDRESS.length *
          this.info.ORG_BRIEF_NAME.length *
          this.info.ORG_FULL_NAME.length >
          0;
      this.info.valid = a;
    },
    checkDocDate() {
      let date = new Date();
      let docDate = this.info.DOC_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let doc_year = parseInt(docDate.split(".")[2]);
      let doc_months = parseInt(docDate.split(".")[1]);
      let doc_days = parseInt(docDate.split(".")[0]);
      if (docDate.length == 10) {
        this.unvalidDocDate = !(
          doc_year < year ||
          (doc_year == year && doc_months < month) ||
          (doc_year == year && doc_months == month && doc_days < day)
        );
      } else if (docDate.length == 0) {
        this.unvalidDocDate = false;
      } else {
        this.unvalidDocDate = true;
      }
    }
  },
  updated() {
    this.checkInformation();
    this.$emit("updated");
  },
  created() {
    this.checkInformation();
    this.getByINN();
  }
};
</script>

<style scoped>
input[type="text"] {
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin-left: 0px;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.left-column {
  width: 30%;
  display: flex;
  flex-direction: column;
}
.right-column {
  width: 70%;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
table {
  border-collapse: collapse;
  padding: 0px 5px;
  width: 100%;
}
tr {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
.necessary {
  color: red;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
label {
  margin-bottom: 10px;
}
p {
  padding-right: 10px;
}
</style>